import { lazy } from './lazyWithRetry';

import { Route } from 'react-router-dom';
import { suspense } from './utils';

const Services = lazy(() => import('app/features/services'));

export default function ServicesRoutes() {
  return <Route path="services" element={suspense(<Services />)} />;
}
